import { useParams } from "react-router-dom";

import { getDisplayString } from "@medplum/core";
import { useMedplumProfile } from "@medplum/react";

import { readBrowserStoredOrganizationId } from "@/utils/read-browser-stored-organization-id";

interface DotPhraseAuthor {
  practiceId: string | undefined;
  practitionerId: string | undefined;
  practitionerDisplay: string;
}

export default function useDotPhraseAuthor(): DotPhraseAuthor {
  const profile = useMedplumProfile();
  const { practiceId } = useParams<{ practiceId: string }>();

  return {
    practiceId: practiceId ?? readBrowserStoredOrganizationId(),
    practitionerId: profile?.id,
    practitionerDisplay: profile ? getDisplayString(profile) : "",
  };
}
